// extracted by mini-css-extract-plugin
export default {"select":"MenuShortcut_select__ZvWQZ","wrapper":"MenuShortcut_wrapper__5RCuk"};